export enum ApplicationSetting {
    DbConnectionString = 'ConnectionString',
    Database = 'Database',
    Domain = 'Domain',
    RedisConnectionString = 'RedisConnectionString',
    EnabledStatus = 'Status',
    Role = 'Role',
    StorageContainer = 'StorageContainer',
}